import React from 'react'
import { Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'
import { Card, Container, Row, Table } from 'reactstrap'
import Transaction from './Transaction'

const RecentTransactionTable = () => {
  return (
    <Container fluid>
        <Card className='p-4'>
            <div className="pb-2 mb-0">
                <h5 className="fw-bold">Recent Order Transactions</h5>
                <p className='text-muted mb-0' style={{fontSize:'0.7rem'}}>Live transaction feed</p>
            </div>

            <Row>
                <Table  className='table table-striped table-bordered'>
                    <Tbody>
                        <Tr>
                            <Transaction/>
                        </Tr>
                    </Tbody>
                </Table>
            </Row>
        </Card>
    </Container>
  )
}

export default RecentTransactionTable
